import styled from "styled-components"
import Colors from "utils/Colors"

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;
  background-color: ${Colors.lightGray};
  border-radius: 4px;
  padding: 1rem 2rem;
  
  & p.name {
    text-transform: capitalize;
  }
  
  & > p > span {
    font-weight: 600;
  }
`
